// Shared item definitions for all Rock in Rio extras components.
// Display detail (tag, title, price, artists) lives here so both the
// grid and row layout components can read from the same source.

export type DayConfig = {
  category: string
  tagKey: string
  titleKey: string
  moreInfoKey?: string
  price?: string
  discountPrice?: string
  disabled?: boolean
  /** Date string shown in the header pill, e.g. "20 JUN" */
  date: string
  /** Headliner act name, displayed in large caps */
  headliner: string
  /** Supporting acts shown below the headliner */
  acts: string[]
  /** CSS gradient for the card header background */
  gradient?: string
}

export const DAYS: DayConfig[] = [
  {
    category: 'rir-day27',
    tagKey: 'extras.rockInRio.tag',
    titleKey: 'extras.rockInRio.day3Title',
    moreInfoKey: 'extras.rockInRio.day3Artists',
    price: '89€',
    discountPrice: '75,65€',
    date: '27 JUN',
    headliner: 'ROD STEWART',
    acts: ['CYNDI LAUPER', 'JOSS STONE', 'SHAGGY'],
    //gradient: 'linear-gradient(160deg, #0f0222 0%, #6b21a8 40%, #0d9488 100%)',
  },
  {
    category: 'rir-day28',
    tagKey: 'extras.rockInRio.tag',
    titleKey: 'extras.rockInRio.day4Title',
    moreInfoKey: 'extras.rockInRio.day4Artists',
    price: '89€',
    discountPrice: '75,65€',
    date: '28 JUN',
    headliner: '21 SAVAGE',
    acts: ['CENTRAL CEE', 'REMA', 'MATUÊ'],
    //gradient: 'linear-gradient(160deg, #0f0222 0%, #7c1d6f 45%, #ea580c 100%)',
  },
  {
    category: 'rir-day20',
    tagKey: 'extras.rockInRio.tag',
    titleKey: 'extras.rockInRio.day1Title',
    moreInfoKey: 'extras.rockInRio.day1Artists',
    disabled: true,
    price: '89€',
    discountPrice: '75,65€',
    date: '20 JUN',
    headliner: 'KATY PERRY',
    acts: ['BEBE REXHA', 'CHARLIE PUTH', 'ALOK'],
    //gradient: 'linear-gradient(160deg, #0f0222 0%, #6b21a8 55%, #db2777 100%)',
  },
  {
    category: 'rir-day21',
    tagKey: 'extras.rockInRio.tag',
    titleKey: 'extras.rockInRio.day2Title',
    moreInfoKey: 'extras.rockInRio.day2Artists',
    disabled: true,
    date: '21 JUN',
    headliner: 'LINKIN PARK',
    acts: ['CYPRESS HILL', 'THE PRETTY RECKLESS', 'KAISER CHIEFS'],
    //gradient: 'linear-gradient(160deg, #0f172a 0%, #1e3a5f 55%, #2563eb 100%)',
  },
]
